import {APP_INITIALIZER, NgModule, Type} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { ChatbotApiService } from './_services/chatbot.service';
// used to create fake backend
import {AppComponent} from './app.component';
import {routing} from './app.routing';
import {AuthGuard, RoleGuard} from './_guards';
import {ErrorInterceptor, JwtInterceptor} from './_helpers';
import {AuthenticationService, UserService} from './_services';
import {MDBBootstrapModule} from 'angular-bootstrap-md';
import {LazyScrollDirective} from './shared/directives/lazy-scroll/lazy-scroll.directive';
import {NotificationService} from './shared/services/notification.service';
import {BrowserNotificationService} from './shared/services/browser-notification.service';
import {CartService} from './_services/cart.service';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ChartistModule} from 'ng-chartist';
import {ServerRequestService} from './_services/serverRequest.service';
import {GuidedTourService} from 'ngx-guided-tour';
import {SharedModule} from './shared/shared.module';
import {CommonModule, DatePipe} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {KioskContainerComponent} from './otherRoles/kiosk/kiosk-container/kiosk-container.component';
import {QrOrderComponent} from './qr-order/qr-order.component';
import {QRCodeModule} from 'angularx-qrcode';
import {CloverAuthRouterModule} from './auth-router/clover-auth-router.module';
import {RatingService} from './_services/ratings.service';
import {AESEncryptDecryptService} from './_services/aesencrypt-decrypt.service';
import {SocketioService} from './_services/socketio.service';
import {QrDeviceService} from './_services/qrDevice.service';
import {ToastrModule} from 'ngx-toastr';
import {MatDialogModule} from '@angular/material/dialog';
import {TableSetupComponent} from './sidebar-menu/table/table-setup/table-setup.component';
import {CartServiceSquare} from './_models/cart.service.square';
import {ViewCartSquareComponent} from './otherRoles/order/view-cart-square/view-cart-square.component';
import {NgOtpInputModule} from 'ng-otp-input';
import {NotifierModule, NotifierOptions} from 'angular-notifier';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import {MatCardModule} from '@angular/material/card';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {JukeboxSocketioService} from './_services/jukeboxSocketio.service';
import {CartAndOrderingService} from './_services/cartAndOrderingService';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { HomeComponent } from './otherRoles/home/home.component';
import {HubLoginComponent} from './hub-login/hub-login.component';
import {NgImageSliderModule} from 'ng-image-slider';
import {_MatMenuDirectivesModule, MatMenuModule} from '@angular/material/menu';
import {OTPLoginService} from './_services/OTPLogin.service';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';;
import { ServiceWorkerModule, SwRegistrationOptions } from '@angular/service-worker'
import { ngswEnabledForClient } from './_helpers/legacy-tv.util'
import { environment } from '../environments/environment'
import { DeviceModeBootService, deviceModeBootFactory } from './_services/device-mode-boot.service'
const materialModules = [
    MatToolbarModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatRadioModule,
    MatCardModule,
    MatIconModule,
    ReactiveFormsModule,
    NgxMaterialTimepickerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule
];

const customNotifierOptions: NotifierOptions = {
    position: {
        horizontal: {
            position: 'right',
            distance: 12
        },
        vertical: {
            position: 'top',
            distance: 75,
            gap: 10
        }
    },
    theme: 'material',
    behaviour: {
        autoHide: 4200,
        onClick: 'hide',
        onMouseover: 'pauseAutoHide',
        showDismissButton: true,
        stacking: 4
    },
    animations: {
        enabled: true,
        show: {
            preset: 'slide',
            speed: 300,
            easing: 'ease'
        },
        hide: {
            preset: 'fade',
            speed: 300,
            easing: 'ease',
            offset: 50
        },
        shift: {
            speed: 300,
            easing: 'ease'
        },
        overlap: 150
    }
};
@NgModule({
    imports: [
        MDBBootstrapModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        SharedModule,
        NgbModule,
        QRCodeModule,
        ChartistModule,
        BrowserModule,
        NotifierModule,
        ToastrModule.forRoot(),
        NgOtpInputModule,
        NgImageSliderModule,
        NotifierModule.withConfig(customNotifierOptions),
        BrowserAnimationsModule,
        CloverAuthRouterModule,
        routing,
        CommonModule,
        NgMultiSelectDropDownModule.forRoot(),
        MatDialogModule,
        ...materialModules,
        _MatMenuDirectivesModule,
        MatMenuModule
,
        // The `enabled` gate is intentionally NOT set here. Angular's AOT
        // compiler statically evaluates this options object and silently drops
        // any non-static `enabled` expression (a runtime UA/pathname check),
        // leaving ngsw enabled everywhere — and an imported-function call here
        // hard-fails the prod build with "Expression form not supported"
        // (app.module.ts:155). The runtime decision lives in the
        // SwRegistrationOptions useFactory provider below, whose body AOT does
        // not analyze. Only the static registrationStrategy stays here.
        ServiceWorkerModule.register('ngsw-worker.js', {
          registrationStrategy: 'registerImmediately'
        })    ],
    declarations: [
        AppComponent,
        LazyScrollDirective,
        KioskContainerComponent,
        QrOrderComponent,
        TableSetupComponent,
        HomeComponent,
        HubLoginComponent,
        ],
    providers: [
        // Runtime ngsw enable/disable. Overrides the SwRegistrationOptions that
        // ServiceWorkerModule.register() supplies for the same token (AppModule's
        // own provider wins). The factory runs during DI at runtime, so it can
        // read navigator/location — which the register() options object can't,
        // because AOT folds that literal at build time. Disables ngsw on the
        // legacy NetCast/SmartTV drive-through TVs (their ~14MB background
        // prefetch starves foreground page loads and wedges boot) and on
        // /confirmation-display kiosk sessions (an old app shell must not survive
        // deployments). See _helpers/legacy-tv.util.ts.
        {
          provide: SwRegistrationOptions,
          useFactory: (): SwRegistrationOptions => ({
            enabled: ngswEnabledForClient(
              (typeof navigator !== 'undefined' && navigator.userAgent) || '',
              (typeof window !== 'undefined' && window.location && window.location.pathname) || ''
            ),
            registrationStrategy: 'registerImmediately'
          })
        },
        AuthGuard,
        RoleGuard,
        AuthenticationService,
        ViewCartSquareComponent,
        UserService,
        AESEncryptDecryptService,
        GuidedTourService,
        CartService,
        CartServiceSquare,
        CartAndOrderingService,
        JukeboxSocketioService,
        DatePipe,
        CloverAuthRouterModule,
        ServerRequestService,
        NotificationService,
        QrDeviceService,
        OTPLoginService,
        RatingService,
        BrowserNotificationService,
        SocketioService,
        {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        ChatbotApiService,
        DeviceModeBootService,
        {
          provide: APP_INITIALIZER,
          useFactory: deviceModeBootFactory,
          deps: [DeviceModeBootService],
          multi: true,
        },
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

declare module '@angular/core' {

    interface ModuleWithProviders<T = any> {
        ngModule: Type<T>;
    }
}
